import { Skeleton } from '@/_components';

export function TermsConditionsLoader() {
  return (
    <article className="flex flex-col overflow-x-hidden">
      <Skeleton className="mt-4 mb-3 h-6 w-full" />
      <article>
        {[0, 1, 3, 4, 5, 6, 7, 8, 9].map((item) => (
          <section key={item} className="border-c-border flex w-full items-center justify-between border-t py-3">
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="mr-1 h-5 w-5" />
          </section>
        ))}
      </article>
    </article>
  );
}
